import { extendTheme } from '@chakra-ui/react';

// Custom Chakra UI theme for Sophie Care
const theme = extendTheme({
    components: {
        Input: {
            baseStyle: {
                field: {
                    borderRadius: 'lg',
                    border: '1px solid',
                    borderColor: 'gray.200',
                    bg: 'white',
                    fontFamily: 'Nunito, sans-serif',
                    fontSize: { base: '14px', md: '20px' },
                    py: 7,
                    boxShadow: 'sm',
                    _focus: {
                        borderColor: 'brand.500 !important',
                        boxShadow: '0 0 0 2px #1080847A !important',
                    },
                    _disabled: {
                        border: '1px solid',
                        borderColor: 'gray.200'
                    }
                },
            },
            sizes: {
                md: {
                    field: {
                        fontSize: 'md',
                        px: 4,
                        py: 2,
                    },
                },
            },
            defaultProps: {
                size: 'md',
                variant: 'outline',
            },
        },
        Button: {
            baseStyle: {
                fontWeight: '700',
                fontSize: ["12px", "16px"],
                py: "11px",
                px: "30px",
                borderRadius: "full",
            },
            variants: {
                solid: {
                    bg: 'brand.500',
                    color: 'white',
                    _hover: {
                        bg: 'brand.600',
                    },
                },
                outline: {
                    borderColor: 'brand.500',
                    color: 'brand.500',
                    _hover: {
                        bg: 'brand.50',
                    },
                },
                text: {
                    bg: 'none',
                    color: 'brand.500',
                    border: 'none',
                    p: 'none',
                    cursor: 'pointer',
                    _hover: {
                        color: 'brand.600'
                    }
                }
            },
            defaultProps: {
                variant: 'solid',
                size: 'md',
            },
        },
        FormLabel: {
            baseStyle: {
                fontWeight: 'semibold',
                color: 'gray.700',
                mb: 1,
            },
        },
        FormControl: {
            baseStyle: {
                mb: 4,
            },
        },
        Heading: {
            variants: {
                // Headline for main titles
                headline: {
                    fontFamily: 'Nunito, sans-serif',
                    fontWeight: 'bold',
                    color: 'brand.500',
                    fontSize: ['24px', null, '52px'], // [mobile, tablet, desktop]
                },
                // Subheadline for section titles
                subHeadline: {
                    fontFamily: 'Nunito, sans-serif',
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: ["18px", "24px"],
                }
            },
        },
        Text: {
            variants: {
                paragraph: {
                    fontFamily: 'Nunito, sans-serif',
                    color: 'black',
                    fontSize: '18px',
                },
                subtitle: {
                    fontFamily: 'Nunito, sans-serif',
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: ["18px", "24px"],
                },
                highlighted: {
                    fontFamily: 'Nunito, sans-serif',
                    fontWeight: 'bold',
                    color: 'brand.500',
                    fontSize: ["20px", "32px"],
                }
            },
        },
        Select: {
            baseStyle: {
                field: {
                    borderRadius: 'lg',
                    border: '1px solid',
                    borderColor: 'gray.200',
                    bg: 'white',
                    fontFamily: 'Nunito, sans-serif',
                    boxShadow: 'sm',
                    _focus: {
                        borderColor: 'brand.500 !important',
                        boxShadow: '0 0 0 2px #1080847A !important',
                    },
                },
            },
            defaultProps: {
                size: 'md',
                variant: 'outline',
            },
        },
    },
    // Brand color palette for Sophie Care
    colors: {
        brand: {
            50: '#e0f7fa',
            100: '#b2ebf2',
            200: '#80deea',
            300: '#4dd0e1',
            400: '#26c6da',
            500: '#108084', // Main brand color
            600: '#0e6e72',
            700: '#0b575a',
            800: '#084042',
            900: '#042728',
        },
        black: '#333333',
    },
    fonts: {
        heading: 'Nunito, sans-serif',
        body: 'Nunito, sans-serif',
    },
});

export default theme; 